import React from "react"
import { useLocation } from "react-router-dom"
import * as url from "_routes/url-names"
import AuthRoute from "_routes/authenticated-route"

const SearchRoute = React.lazy(() => import("_modules/search/search-results"))
const CustomerService = React.lazy(() => import("_containers/customer-service"))
const Candidates = React.lazy(() => import("_containers/candidates"))
const CandidateProfile = React.lazy(() => import("_containers/candidate-profile"))
const Statistics = React.lazy(() => import("_containers/statistics"))

function RemountedSearch() {
  const { key } = useLocation()
  return <SearchRoute key={key} />
}

export default [
  {
    path: url.COMPANY + url.SOK,
    element: <AuthRoute key={location.key} component={RemountedSearch} />,
  },
  {
    path: url.COMPANY + url.KUNDSERVICE,
    element: <AuthRoute component={CustomerService} />,
  },
  {
    path: url.COMPANY + url.KANDIDAT,
    element: <AuthRoute component={Candidates} />,
  },
  {
    path: url.COMPANY + url.KANDIDAT + url.KANDIDAT_ID,
    element: <AuthRoute component={CandidateProfile} />,
  },
  {
    path: url.COMPANY + url.STATISTIK,
    element: <AuthRoute component={Statistics} />,
  },
]
